import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../common/Context/AuthContext';

function ProductsGridHome({
  products,
  productCardGradients,
  productCardBoxShadow,
}) {
  const { user } = useAuth();
  const navigate = useNavigate();
  // Only show up to 4 products
  const visibleProducts = products.slice(0, 4);
  const handleTryNow = (product) => {
    if (user) {
      navigate(
        `/products#/try/${product.productId}?category=${encodeURIComponent(
          product.productCategory || ''
        )}`
      );
    } else {
      navigate(
        `/login?redirectProduct=${
          product.productId
        }&category=${encodeURIComponent(product.productCategory || '')}`
      );
    }
  };
  return (
    <div className="row mt-4 pt-3">
      {visibleProducts.map((product, index) => {
        const backgroundGradient =
          productCardGradients[index % productCardGradients.length];
        const boxShadow =
          productCardBoxShadow[index % productCardBoxShadow.length];
        return (
          <div key={product.id} className="col-12 col-lg-3 col-md-6 mb-2">
            <div className="h-100 d-flex flex-column bg-black justify-content-between p-4 homepageCard">
              <div className="position-relative d-flex">
                <div
                  className="align-items-center br_10 d-flex h_45x justify-content-center my-2 p-2 position-relative w_45x zi_10"
                  style={{
                    background: backgroundGradient,
                    boxShadow: boxShadow,
                  }}
                >
                  <i
                    className={`fa-solid fa-layer-group text-white font_15`}
                  ></i>
                </div>
                <div className="homeProductCardIconMain"></div>
              </div>
              <div className="">
                <h3 className="text-white mb-2 font_19 ">
                  {product.productTitle}
                </h3>
                <p className="text-white font_14 font_400">
                  {product.productSubTitle}
                </p>
              </div>
              <div
                className="px-3 py-1 mb-3 font_600 rounded-pill text-white w_fit_content font_12"
                style={{
                  background: backgroundGradient,
                  boxShadow: boxShadow,
                }}
              >
                {`${product.productWeightage} credit/ Hit`}
              </div>
              {product.isActive ? (
                <div
                  className="d-flex align-items-baseline gap-2 text-white cursor-pointer"
                  onClick={() => handleTryNow(product)}
                >
                  Try Now <i className="fas fa-arrow-right text-white ms-1"></i>
                </div>
              ) : (
                <div className="coming-soon-badge text-white font_13 font_400">
                  🚀 Coming Soon
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default React.memo(ProductsGridHome);
